export default __webpack_public_path__ + "static/media/student-mastery-profile.18b37f14.png";